import { css } from "@emotion/core";
import { color, fonts, fontSizes } from "../../theme/Theme";

export const KYCStyles = css({
  ".upload-header": {
    fontSize: fontSizes.title,
    fontFamily: fonts.bold
  },
  ".file-upload-title": {
    fontSize: fontSizes.title,
    fontFamily: fonts.bold,
    color: color.secondary
  },
  ".mandatory-custom-style": {
    color: color.danger
  },
  ".field-seperator": {
    borderBottom: `1px solid ${color.border}`
  },
  ".ant-divider-dashed": {
    borderTopWidth: "2px"
  },
  ".download-pdf": {
    marginRight: "10px" // to align with upload icon
  }
});
